import type { MessageResponse } from '../types';

// Changes when a newer reply arrives, and when the short answer becomes the long one on the same row.
export function latestReplyKey(messages: MessageResponse[]): string | null {
  const latest = messages.find((m) => m.role === 'assistant' && m.status === 'completed');
  return latest ? `${latest.id}:${Boolean(latest.loading_more)}` : null;
}

// What the reply is doing now. The server never clears it, so it only counts while the row is processing.
// Old servers send nothing, and the dots show alone.
export function replyStageLabel(msg: MessageResponse): string | null {
  if (msg.role !== 'user' || msg.status !== 'processing') return null;
  const metadata = msg.message_metadata as { reply_progress?: { label?: unknown } | null } | null | undefined;
  const label = metadata?.reply_progress?.label;
  return typeof label === 'string' && label.trim() ? label : null;
}

// Under a question still running, and under a short answer while the same row becomes the long one. The status decides
// and not the row that follows: a later question, an SMS or an earlier question's answer can sort between a question and
// its reply. A short answer right under the question draws the dots itself.
export function isThinking(msg: MessageResponse, next?: MessageResponse): boolean {
  if (msg.loading_more) return true;
  return msg.role === 'user' && (msg.status === 'pending' || msg.status === 'processing') && !next?.loading_more;
}
